// extracted by mini-css-extract-plugin
export var dropdownButton = "_35-0";
export var fullWidthDropdownButton = "_35-1";
export var icon = "_35-3";
export var iconPlaceholder = "_35-2";
export var shortcutContainer = "_35-4";